import "./Planner.tag"

import introduction from "./introduction"
import usage from "./usage"
import treeview from "./treeview"

export default [
    introduction,
    usage,
    treeview
]



// WEBPACK FOOTER //
// ./docs/riot/plan/index.js